import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {MenuItem} from 'primeng/api';
import {forkJoin, Observable} from 'rxjs';
import {User} from '../../_models';
import {AlertService, AuthenticationService, TenantService, UserService} from '../../_services';
import {AccessRequestService} from '../../_services/accessRequest.service';
import {IndexConfigService} from '../../_services/index.config.service';
import {LoginHelper, Role, RoleHelper, StringsHelper} from '../../helpers';
import {Constants} from '../../helpers/constants';
import {MessageComponent} from '../message';

@Component({
    standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isLoggedIn1: Observable<boolean>;
  isChangePasswordRequired: boolean;
  currentUser: User;

  isHomeVisible: boolean;
  isDashboardVisible: boolean;
  isUsersVisible: boolean;
  isVaultVisible: boolean;
  isControlItemsVisible: boolean;
  isTenantsVisible: boolean;
  isDocumentsVisible: boolean;
  isAlertsVisible: boolean;
  isBulletinsVisible: boolean;
  accountProfileVisible: boolean;
  terminateSessionsVisible: boolean;
  isTrainingsVisible: boolean;
  isItProfileTemplatesVisible: boolean;
  isPolicyVisible: boolean;
  isWorkstreamsVisible: boolean;
  isRisksVisible: boolean;
  isLogsVisible: boolean;
  isApiVisible: boolean;
  isDirectivesVisible: boolean;
  isCveVisible: boolean;
  tenantName: string;
  userToken: string = LoginHelper.getFileToken();
  isAuditVisible: boolean;
  isSupportVisible: boolean;
  isImplementationControlStatementsVisible: boolean;
  api = window.location.origin;
  accessRequest;
  isIncidentResponseVisible: boolean = false;
  isEvidenceArchiveVisible: boolean;
  isRequestListVisible = false;
  isAssessmentsVisible: boolean = false;
  items: MenuItem[] = [];
  isTrustBuilderVisible: boolean;
  isTrustBuilderViewVisible: boolean;
  IsElixirEnabled: boolean;
  IsAutonomyEnabled: boolean;

  settings: any;
  tenants = [];

  constructor(
    public authService: AuthenticationService,
    public router: Router,
    public alertService: AlertService,
    public userService: UserService,
    public dialog: MatDialog,
    public tenantService: TenantService,
    public accessRequestService: AccessRequestService,
    public config: IndexConfigService
  ) {
    this.tenantName = LoginHelper.getTenantName();
    this.tenantName = this.tenantName
      ? this.tenantName.toLowerCase()
      : this.tenantName;
  }

  ngOnInit() {
    this.isLoggedIn1 = this.authService.isLoggedIn;

    this.isLoggedIn1.subscribe((data) => {
      this.currentUser = this.getCurrentUser();
      if (this.currentUser != null) {
        this.tenants = [];
        for (let i = 0; i < this.currentUser.tokens.length; i++) {
          this.tenants.push(this.currentUser.tokens[i].key.tenantName);
        }

        this.accessRequestService.getAccessRequestForUser().subscribe((r) => {
          this.accessRequest = r;
        });

        //console.log('role');
        //console.log(this.currentUser.role);
        var requests = [this.tenantService.getCurrent()];
        if (LoginHelper.getTenantName() !== Constants.RiskSpongeMaster) {
          requests.push(this.userService.getPublicManagers(LoginHelper.getTenantName()));
        }
        forkJoin(requests)
          .subscribe((datas) => {
            const p = datas[0];
            let labels = {};
            if (datas.length > 1) {
              this.settings = datas[1].settings;
              labels = this.settings.menuLabels || {};
            }
            if (p && p.expires) {
              const last = moment(p.expirationDate).diff(moment(), 'days');
              if (last >= 0 && last < 10) {
                let dialogRef = this.dialog.open(MessageComponent, {
                  width: '250px',
                  data: {
                    title: '',
                    text:
                      'Access expires in ' +
                      last +
                      ' days. Please contact your manager',
                    button: 'Ok',
                  },
                });
              }
            }

            this.isHomeVisible =
              this.currentUser.role != Role.KingAdmin &&
              this.currentUser.role != Role.Vendor &&
              this.currentUser.role != Role.Admin &&
              this.currentUser.role != Role.Training &&
              this.currentUser.role != Role.Survey &&
              this.currentUser.role != Role.Engineer &&
              this.currentUser.role != Role.IncidentResponse &&
              this.currentUser.role != Role.TrustCenterViewer;
            this.isDashboardVisible = RoleHelper.isDashboardVisible(this.currentUser.role) && (!p || p.isProjectsEnabled);

            this.isChangePasswordRequired =
              this.currentUser.isChangePasswordRequired;

            this.isUsersVisible = RoleHelper.isUsersVisible(this.currentUser.role);

            this.isVaultVisible = RoleHelper.isVaultVisible(this.currentUser.role);

            this.isControlItemsVisible =
              ((this.currentUser.role & Role.KingAdmin) != 0 ||
                (this.currentUser.role & Role.Admin) != 0 ||
                (this.currentUser.role &
                  (Role.PrimaryAdvisorLead | Role.PlatformSupport)) !=
                0 ||
                (this.currentUser.role & Role.PrimaryManager) != 0) &&
              (!p || p.isControlsEnabled);

            this.isTenantsVisible = LoginHelper.getTenantName() === Constants.RiskSpongeMaster && RoleHelper.isTenantsVisible(this.currentUser.role);

            this.isDocumentsVisible = RoleHelper.isDocumentsVisible(this.currentUser.role);

            this.isTrainingsVisible =
              this.currentUser.role != Role.Assessor &&
              this.currentUser.role != Role.Vendor &&
              (p == null || p.isTrainingEnabled) &&
              this.currentUser.role != Role.Survey &&
              this.currentUser.role != Role.Engineer &&
              this.currentUser.role != Role.IncidentResponse &&
              this.currentUser.role != Role.TrustCenterViewer;

            this.isItProfileTemplatesVisible = RoleHelper.isItProfileTemplatesVisible(this.currentUser.role);

            this.isAssessmentsVisible =
              (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0 ||
              (this.currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0 ||
              (this.currentUser.role & (Role.Survey)) != 0 ||
              (this.currentUser.role & Role.KingAdmin) != 0 ||
              (this.currentUser.role & Role.Admin) != 0;

            this.isWorkstreamsVisible =
              (this.currentUser.role & Role.KingAdmin) != 0 ||
              (this.currentUser.role & Role.Admin) != 0 ||
              (this.currentUser.role & Role.Engineer) != 0 ||
              (p && p.isWorkstreamsEnabled && this.isItProfileTemplatesVisible && (this.currentUser.role & Role.Survey) == 0);

            this.isPolicyVisible =
              (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) !=
              0 ||
              (this.currentUser.role &
                (Role.AdvisorLead |
                  Role.PrimaryAdvisorLead |
                  Role.PlatformSupport)) !=
              0 ||
              (this.currentUser.role & Role.KingAdmin) != 0 ||
              (this.currentUser.role & Role.Admin) != 0;

            this.isApiVisible =
              ((this.currentUser.role & (Role.Manager | Role.PrimaryManager)) !=
                0 ||
                (this.currentUser.role &
                  (Role.AdvisorLead |
                    Role.PrimaryAdvisorLead |
                    Role.PlatformSupport)) !=
                0) &&
              (!p || p.isAPIEnabled);
            this.isDirectivesVisible =
              (this.currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.Manager | Role.PrimaryManager | Role.PlatformSupport)) != 0;

            this.isCveVisible = (this.currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.Manager | Role.PrimaryManager | Role.PlatformSupport | Role.Admin | Role.KingAdmin)) != 0;

            this.isAlertsVisible =
              this.currentUser.role != Role.KingAdmin &&
              this.currentUser.role != Role.Admin &&
              this.currentUser.role != Role.Assessor;
            this.isBulletinsVisible = LoginHelper.getTenantName() === Constants.RiskSpongeMaster &&
              ((this.currentUser.role & Role.KingAdmin) != 0 ||
                (this.currentUser.role & Role.Admin) != 0);
            this.terminateSessionsVisible =
              (this.currentUser.role & Role.KingAdmin) != 0;
            this.accountProfileVisible =
              (this.currentUser.role & Role.KingAdmin) != 0 ||
              (this.currentUser.role & Role.PrimaryManager) != 0 ||
              (this.currentUser.role &
                (Role.PrimaryAdvisorLead | Role.PlatformSupport)) !=
              0;
            this.isRisksVisible =
              ((this.currentUser.role &
                  (Role.AdvisorLead |
                    Role.PrimaryAdvisorLead |
                    Role.PlatformSupport)) !=
                0 ||
                (this.currentUser.role & Role.AdvisorStaff) != 0 ||
                (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) !=
                0 ||
                (this.currentUser.role & Role.User) != 0) &&
              (!p || p.isRisksEnabled);
            this.isAuditVisible =
              ((this.currentUser.role &
                  (Role.AdvisorLead |
                    Role.PrimaryAdvisorLead |
                    Role.PlatformSupport)) !=
                0 ||
                (this.currentUser.role & Role.AdvisorStaff) != 0 ||
                (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) !=
                0 ||
                (this.currentUser.role & Role.KingAdmin) != 0 ||
                (this.currentUser.role & Role.Admin) != 0 ||
                (this.currentUser.role & Role.Assessor) != 0 ||
                (this.currentUser.role & Role.User) != 0) &&
              (!p || p.isAuditEnabled);
            this.isLogsVisible =
              ((this.currentUser.role &
                  (Role.AdvisorLead |
                    Role.PrimaryAdvisorLead |
                    Role.PlatformSupport | Role.Manager | Role.PrimaryManager)) !=
                0) &&
              (!p || p.isLoggingEnabled);

            this.isIncidentResponseVisible =
              (this.currentUser.role &
                (Role.AdvisorLead |
                  Role.PrimaryAdvisorLead |
                  Role.PlatformSupport |
                  Role.AdvisorStaff |
                  Role.Manager |
                  Role.PrimaryManager |
                  Role.User |
                  Role.IncidentResponse)) !=
              0;

            this.isRequestListVisible = (this.currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport | Role.AdvisorStaff | Role.Manager | Role.PrimaryManager | Role.User | Role.KingAdmin)) !== 0;

            this.isSupportVisible = LoginHelper.getTenantName() === Constants.RiskSpongeMaster &&
              (this.currentUser.role &
                (Role.KingAdmin | Role.Admin | Role.Support)) !=
              0;

            this.isImplementationControlStatementsVisible =
              (this.currentUser.role &
                (Role.KingAdmin |
                  Role.Admin |
                  Role.Support |
                  Role.AdvisorLead |
                  Role.PrimaryAdvisorLead |
                  Role.PlatformSupport |
                  Role.PrimaryManager)) !=
              0 &&
              (!p || p.isImplementationControlStatementsEnabled);

            this.isTrustBuilderVisible = (this.currentUser.role !== Role.TrustCenterViewer) && p && p.isTrustBuilderEnabled;
            this.isTrustBuilderViewVisible = !this.isTrustBuilderVisible && p && p.isTrustBuilderEnabled;
            this.IsElixirEnabled = p && p.IsElixirEnabled;
            this.IsAutonomyEnabled = p && p.isAutonomyEnabled;

            this.items = [
              {
                label: labels['Govern'] || 'Govern',
                visible: true,
                icon: 'pi pi-box',
                items: [
                  {
                    visible: this.isPolicyVisible,
                    label: labels['Policies'] || 'Policies',
                    routerLink: '/policy',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-book',
                  },
                  {
                    visible: this.isRisksVisible,
                    label: labels['RizkList'] || 'RizkList',
                    routerLink: '/risks',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-exclamation-triangle',
                  },
                  {
                    visible: this.isTrainingsVisible,
                    label: labels['Awareness'] || 'Awareness',
                    routerLink: '/training',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-sun',
                  },
                  {
                    visible: this.isAssessmentsVisible,
                    label: labels['Forms'] || 'Forms',
                    routerLink: '/assessments',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-file',
                  },
                ]
              },
              {
                label: labels['Operate'] || 'Operate',
                icon: 'pi pi-send',
                visible: true,
                items: [
                  {
                    visible: this.isHomeVisible,
                    label: labels['Dashboard'] || 'Dashboard',
                    routerLink: '/home',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-chart-bar',
                  },
                  {
                    visible: this.isDashboardVisible,
                    label: labels['Projects'] || 'Projects',
                    routerLink: '/projects',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-share-alt',
                  },
                  {
                    visible: this.isDashboardVisible,
                    label: labels['POAM Mgmt'] || 'POAM Mgmt',
                    routerLink: '/projects/globalPoams',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-share-alt',
                  },
                  {
                    visible: this.isDirectivesVisible || this.isApiVisible,
                    label: labels['Directives'] || 'Directives',
                    routerLink: '/evidence-central',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-code',
                  },
                  {
                    visible: this.isWorkstreamsVisible,
                    label: labels['Workstreams'] || 'Workstreams',
                    routerLink: '/workstreams',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-sitemap',
                  },
                  {
                    visible: this.isIncidentResponseVisible,
                    label: labels['IR'] || 'IR',
                    routerLink: '/incidentResponse',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-exclamation-triangle',
                  },
                ],
              },
              {
                label: labels['Demonstrate'] || 'Demonstrate',
                visible: true,
                icon: 'pi pi-verified',
                items: [
                  {
                    visible: this.isDocumentsVisible,
                    label: labels['Documents'] || 'Documents',
                    routerLink: 'documents',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-folder',
                  },
                  {
                    visible: this.isRequestListVisible,
                    label: labels['Request Lists'] || 'Request Lists',
                    routerLink: 'documents/requestList',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-exclamation-triangle',
                  },
                  {
                    visible: this.isAuditVisible,
                    label: labels['Audit Prep'] || 'Audit Prep',
                    routerLink: '/audit',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-check-square',
                  },
                  {
                    visible: this.isTrustBuilderVisible,
                    label: labels['Trust Builder'] || 'Trust Builder',
                    routerLink: '/trustBuilder',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-thumbs-up',
                  },
                  {
                    visible: this.isTrustBuilderViewVisible,
                    label: labels['Trust Builder'] || 'Trust Builder',
                    routerLink: '/trustBuilderView',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-thumbs-up',
                  },
                ],
              },
              {
                label: labels['Systems'] || 'Systems',
                visible: true,
                icon: 'pi pi-verified',
                items: [
                  {
                    visible: this.isItProfileTemplatesVisible,
                    label: labels['Profiles'] || 'Profiles',
                    routerLink: '/profiles/itProfile',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-id-card',
                  },
                  {
                    visible: this.isItProfileTemplatesVisible,
                    label: labels['Devices'] || 'Devices',
                    routerLink: '/globalDevices',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-mobile',
                  },
                  {
                    visible: this.isCveVisible,
                    label: labels['CVE'] || 'CVE',
                    routerLink: '/cve',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-share-alt',
                  },
                  {
                    visible: this.isItProfileTemplatesVisible,
                    label: labels['SAP'] || 'SAP',
                    routerLink: '/profiles/sapProfile',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-map',
                  },
                  {
                    visible: this.isItProfileTemplatesVisible,
                    label: labels['SAR'] || 'SAR',
                    routerLink: '/profiles/sarProfile',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-align-justify',
                  },
                  {
                    visible: this.isItProfileTemplatesVisible,
                    label: labels['ConMon'] || 'Package',
                    routerLink: '/profiles/conMonProfile',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-calendar',
                  },
            ]
              },
              {
                label: labels['Admin'] || 'Admin',
                visible: true,
                icon: 'pi pi-shield',
                items: [
                  {
                    visible: this.isTenantsVisible,
                    label: labels['Tenants'] || 'Tenants',
                    routerLink: '/tenants',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-building',
                  },
                  {
                    visible: this.isApiVisible,
                    label: labels['Integrations'] || 'Integrations',
                    routerLink: '/integrations',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-cog',
                  },
                  {
                    visible: this.isLogsVisible,
                    label: labels['Logging'] || 'Logging',
                    routerLink: '/log',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-history',
                  },
                  {
                    visible: this.isControlItemsVisible,
                    label: labels['Controls'] || 'Controls',
                    routerLink: '/controlItems',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-list',
                  },
                  {
                    visible: this.isUsersVisible,
                    label: labels['Users'] || 'Users',
                    routerLink: '/users',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-users',
                    iconClass: 'menu-icon',
                  },
                  /*{
                    visible: this.isRequestListVisible,
                    label: labels['Multi Login'] || 'Multi Login',
                    routerLink: '/multilogin',
                    routerLinkActiveOptions: {exact: true},
                  },*/
                  {
                    visible: this.isBulletinsVisible,
                    label: labels['Bulletins'] || 'Bulletins',
                    routerLink: '/bulletins',
                    routerLinkActiveOptions: {exact: true},
                  },
                  {
                    visible: this.isTenantsVisible,
                    label: labels['Editions'] || 'Editions',
                    routerLink: '/tenantPermissions',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-tags',
                  },
                  {
                    visible: this.isSupportVisible,
                    label: labels['Support'] || 'Support',
                    routerLink: '/support',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-life-ring',
                  },
                  {
                    visible: this.isTenantsVisible,
                    label: labels['Multiverse'] || 'Multiverse',
                    routerLink: '/multiverse',
                    routerLinkActiveOptions: {exact: true},
                  },
                  {
                    visible: this.isVaultVisible,
                    label: labels['The Vault'] || 'The Vault',
                    routerLink: '/dictionaries',
                    routerLinkActiveOptions: { exact: true },
                    icon: 'pi pi-palette',
                  },
                ],
              }
            ];

            this.items.forEach((i) => {
              i.items.forEach(s => {
                s.routerLinkActiveOptions = {exact: false};
              });
              const firstVisible = i.items.find((s) => s.visible);
              const active = i.items.find((s) =>
                window.location.pathname.startsWith(s.routerLink)
              ) || i.items.find((s) => s.items && s.items.find((ss) => window.location.pathname.startsWith(ss.routerLink)));
              i.visible = firstVisible != null;
              active && (i.expanded = true);
            });
          });
      }
    });

    if (LoginHelper.getTenantName() !== Constants.RiskSpongeMaster) {
      this.userService.accountUpdated.subscribe((u) => {
        this.settings = u.settings;
      });
    } else {
      this.settings = {
        menuColor: '#FFFFFF',
        menuFontColor: '#000000',
        subMenuFontColor: '#000000',
      };
    }

    this.currentUser = this.getCurrentUser();
  }

  clearAlerts() {
    this.alertService.clear();
  }

  onLogout() {
    this.alertService.clear();
    this.authService.logout();
  }

  onEditClientProfile() {
    this.router.navigate(['/clientProfile']);
  }

  public getCurrentUser(): User {
    return JSON.parse(sessionStorage.getItem('currentUser'));
  }

  public getUserName(): string {
    let currentUser = this.getCurrentUser();
    if (currentUser != null && currentUser.emailAddress != null) {
      return currentUser.emailAddress.split('@')[0];
    }

    if (currentUser != null && currentUser.userName != null) {
      return currentUser.userName;
    }

    return '';
  }

  public getRole(): string {
    return StringsHelper.getRole(this.getCurrentUser().role);
  }

  setRequestStatus(value) {
    this.accessRequestService
      .setAccessRequestStatus(this.accessRequest, value)
      .subscribe((r) => {
        this.accessRequest = null;
      });
  }

  setTenant($event) {
    const user = JSON.parse(sessionStorage.getItem('currentUser'));
    const tenantUser = user.tokens.find(
      (u) => u.key.tenantName === $event.value
    );
    user.token = tenantUser.value;
    user.fileAccessKey = tenantUser.key.fileAccessKey;
    user.role = tenantUser.key.role;
    user.tenantName = $event.value;
    sessionStorage.setItem('currentUser', JSON.stringify(user));
    window.location.reload();
  }

  terminateSessions() {
    this.authService.terminateSessions();
  }
}
